import Axios from '@/axios'

// 查询授权资源包模板：web:adc:index
export const QueryAdcList = data => {
  return Axios({
    url: '/device-manager/web-api/adc/index',
    method: 'POST',
    type: 'json',
    data
  })
}

export const QueryAdcInfo = data => {
  return Axios({
    url: `/device-manager/web-api/adc/show`,
    method: 'POST',
    type: 'json',
    data
  })
}
